import { styled } from '@mui/material';

const ReportInfoBlockList = styled('ul')({
	display: 'flex',
	width: '100%',
	gap: '8px',
	flexDirection: 'column',
	padding: 0,
	margin: 0,
});

export default ReportInfoBlockList;
